export default "__VITE_ASSET__de4ebd39__"